package ru.it_mozaika.sender.js.application.frames.catalog


import emotion.react.css
import io.ktor.client.call.*
import js.core.jso
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import mui.icons.material.AccountTreeSharp
import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.aria.ariaLabel
import react.dom.html.ReactHTML.img
import react.router.useNavigate
import ru.it_mozaika.components.AvatarButton
import ru.it_mozaika.components.searchField
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.common.models.Product
import ru.it_mozaika.sender.common.models.TableColumn
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.components.catalog.CatalogTreeDialog
import ru.it_mozaika.sender.js.application.components.catalog.IdsCopyDialog
import ru.it_mozaika.sender.js.application.components.subscribers.fieldSelectDialog
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.ColumnDef
import tanstack.table.core.ColumnDefTemplate
import tanstack.table.core.StringOrTemplateHeader
import tanstack.table.core.getCoreRowModel
import web.cssom.*
import web.html.Loading
import web.navigator.navigator
import web.window.WindowTarget

val CatalogFrame = VFC {

    var products by useState(listOf<Product>())
    val storeContext = useContext(StoreContext)
    val backDrop = useContext(BackdropContext)
    val navigate = useNavigate()
    var size by useState<Long>(0)
    var rowsPerPage by useState(10)
    var page by useState(0)
    val (searchQuery, setSearchQuery) = useState("")
    val (columns, setColumns) = useState(listOf<TableColumn>())
    var selectedCategories by useState<List<String>>(listOf())
    var selectedFields by useState<List<String>>(listOf())
    var selectedProducts by useState<List<Product>>(listOf())
    val selectedColumns = useMemo(columns, selectedFields) {
        if (selectedFields.isNotEmpty()) {
            columns.filter { selectedFields.contains(it.name) }
        } else {
            columns
        }
    }
    var showFieldSelectDialog by useState(false)
    val storage = kotlinx.browser.localStorage
    var showCopyDialog by useState(false)
    var showCatalogTree by useState(false)

   useEffect(columns, storeContext.currentStoreId) {
        if (!storage.getItem("${storeContext.currentStoreId}-products-columns-order").isNullOrBlank()) {
            val encodedString = storage.getItem("${storeContext.currentStoreId}-products-columns-order")
            val columnsOrder = try {
                Json.decodeFromString<List<TableColumn>>(encodedString!!)
            } catch (e: Exception) {
                listOf()
            }
            if (columns !== columnsOrder) {
                setColumns(columnsOrder)
            }
        }
    }
   useEffect(columns, storeContext.currentStoreId ) {
       if (!storage.getItem("${storeContext.currentStoreId}-products-visible-columns").isNullOrBlank()) {
           val encodedString = storage.getItem("${storeContext.currentStoreId}-products-visible-columns")
           val selected = try {
               Json.decodeFromString<List<String>>(encodedString!!)
           } catch (e: Exception) {
               listOf()
           }
           if (selected != selectedFields) {
               selectedFields = selected
           }
       } else {
           selectedFields = columns.map { it.name }
       }
   }
   useEffect(columns, storeContext.currentStoreId){
       if (!storage.getItem("${storeContext.currentStoreId}-selected-categories").isNullOrBlank()) {
           val encodedString = storage.getItem("${storeContext.currentStoreId}-selected-categories")
           val selected = try {
               Json.decodeFromString<List<String>>(encodedString!!)
           } catch (e: Exception) {
               listOf()
           }
           if (selected != selectedCategories) {
               selectedCategories = selected
           }
       }
   }

    val table = useReactTable<Product>(
        options = jso {
            this.columns = useMemo(selectedColumns) {
                selectedColumns.map { column ->
                    jso<ColumnDef<Product, Any?>> {
                        accessorFn = { product, _ ->
                            when (column.name) {
                                "ID" -> product.id
                                "available" -> if (product.available) "Да" else "Нет"
                                "name" -> product.name
                                "picture" -> product.picture
                                "url" -> product.url ?: "---"
                                "description" -> product.description
                                "vendor" -> product.vendor ?: "---"
                                "vendorCode" -> product.vendorCode ?: "---"
                                "price" -> product.price.toString()
                                "oldPrice" -> product.oldPrice?.toString() ?: "---"
                                "Vendor link",
                                "Вес",
                                "Возраст",
                                "Серия",
                                "barcode" -> product.params[column.name] ?: "---"
                                else -> "---"
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val columnId = context.column.id
                            val value = context.getValue().toString()
                            when(columnId) {
                                "picture" -> Box.create {

                                    sx {
                                        width = 145.px
                                        height = 145.px
                                    }
                                        img {
                                            css {
                                                width = 140.px
                                                height = 140.px
                                            }
                                            src = value
                                            loading = Loading.lazy
                                        }

                                }
                                "url",
                                "Vendor link" ->Box.create {
                                    Link {
                                        target = WindowTarget._blank
                                        href = value
                                        +value
                                    }
                                }

                                else -> Box.create {
                                    sx{
                                        if(columnId == "description"){
                                            maxHeight = 200.px
                                        }
                                        this.overflow = Overflow.hidden
                                    }
                                    +value
                                }
                            }
                        }
                        this.id = column.name
                        this.header = StringOrTemplateHeader(column.ruTitle)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(products) {
                products.toTypedArray()
            }
            this.getCoreRowModel = getCoreRowModel()
        }

    )

    fun getProducts() {
        if (storeContext.currentStoreId != null) {
            backDrop.show()
            Http.post(
                "/catalog/products",
                body = selectedCategories,
                query = mapOf(
                    "store" to storeContext.currentStoreId!!,
                    "search" to searchQuery,
                    "skip" to (page + 1).toString(),
                    "limit" to rowsPerPage.toString()
                )
            ) { response ->
                backDrop.hide()
                products = response.body()
            }
            Http.post(
                "/catalog/products/size",
                body = selectedCategories,
                query = mapOf(
                    "store" to storeContext.currentStoreId!!,
                    "skip" to (page + 1).toString(),
                    "limit" to rowsPerPage.toString()
                )
            ) { response ->

                size = response.body<Long>()
            }
        }
    }

    useEffect(storeContext.currentStoreId, selectedCategories, rowsPerPage, page, searchQuery) {
        getProducts()
    }

    useEffect(products) {
        val productsField = mutableListOf(
            TableColumn("ID", "ID"),
            TableColumn("available", "Товар в наличии"),
            TableColumn("name", "Наименование"),
            TableColumn("url", "Ссылка"),
            TableColumn("picture", "Изображение"),
            TableColumn("price", "Цена"),
            TableColumn("oldPrice", "Старая цена"),
            TableColumn("description", "Описание"),
            TableColumn("vendor", "Поставщик"),
            TableColumn("vendorCode", "Код поставщика"),
        )
        val params = products.map { product ->
            product.params.map { it.key }
        }.flatten()
            .toSet()
            .mapNotNull {
                when (it) {
                    "Vendor link" -> TableColumn(it, "Страница поставщика")
                    "barcode" -> TableColumn(it, "Штрихкод")
                    "Вес" -> TableColumn(it, it)
                    "Возраст" -> TableColumn(it, it)
                    "Серия" -> TableColumn(it, it)
                    else -> null

                }
            }
        productsField += params
        setColumns(productsField)
    }

    fieldSelectDialog {
        isOpen = showFieldSelectDialog
        this.columns = useMemo(columns) { columns }
        primaryKey = listOf("ID")
        this.selectedFields = selectedFields
        this.onClose = {
            showFieldSelectDialog = !showFieldSelectDialog
        }
        this.changeHandler = {
            selectedFields = it
            val encodedString = Json.encodeToString(it)
            storage.setItem("${storeContext.currentStoreId}-products-visible-columns", encodedString)
        }
        onSwapHandler = { list ->
            val fieldsWithNewOrder = list.mapNotNull { name ->
                columns.find { it.name == name }
            }
            setColumns(fieldsWithNewOrder)
            val encodedString = Json.encodeToString(fieldsWithNewOrder)
            storage.setItem("${storeContext.currentStoreId}-products-columns-order", encodedString)
        }
    }
    IdsCopyDialog{
        isOpen = showCopyDialog
        onClose ={
            showCopyDialog = false
        }
        ids = selectedProducts.map{it.id}
    }
        CatalogTreeDialog {
            onClose = { showCatalogTree = false }
            isOpen = showCatalogTree
            this.onSelect = {
                selectedCategories = it
                val encodedString = Json.encodeToString(it)
                storage.setItem("${storeContext.currentStoreId}-selected-categories", encodedString)
            }
        }


    MainCard {
        title = "Каталог товаров"
        actions = Stack.create {
            this.direction = responsive(StackDirection.row)

            ariaLabel = "catalog-button-group"
            asDynamic().spacing = 2
            sx {

                this.width = 100.pct
                border = 2.px
                this.alignItems = AlignItems.center
                this.justifyContent = JustifyContent.flexEnd
            }
            AvatarButton {
                tooltipTitle = "Управление полями"
                mui.icons.material.SettingsSharp()
                onClick = {
                    showFieldSelectDialog = true
                }
            }
            Badge {
                badgeContent = ReactNode(selectedCategories.size.toString())
                color = BadgeColor.secondary
                Button {
                    +"Категории"
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    this.startIcon = AccountTreeSharp.create()
                    onClick = {
                        showCatalogTree = true
                    }
                }
            }

        }
        Toolbar {
            sx {
                display = Display.flex
                flexWrap = FlexWrap.wrap
                paddingTop = 2.px
            }

            Stack {
                this.direction = responsive(StackDirection.row)

                asDynamic().spacing = 2
                sx {
//                        this.maxHeight = 50.px
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                searchField {
                    this.onSearchQueryChange = {
                        setSearchQuery(it)
                    }
                    placeHolder = "ID, Наименование, поставщик: "
                }
                StoresSelect()

            }
        }
        commonTableSkeletonFrame {
            this.toolbarActions = Stack.create() {
                this.direction = responsive(StackDirection.row)
                ariaLabel = "products-table-button-group"
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexEnd
                }

                AvatarButton {
                    this.tooltipTitle = "Копировать ID"
                    mui.icons.material.ContentCopySharp()
                    onClick = {
                        showCopyDialog = true
                        navigator.clipboard.writeText(selectedProducts.joinToString(",") { it.id })
                    }
                }
            }
            this.table = table
            this.dataCount = products.size
            this.propertiesFilter = listOf()
            this.onPropertySelect = {}
            this.columnId = "ID"
            this.label = "products"
            this.onDoubleClickHandler = {
                navigate("/catalog/$it")
            }
            this.onSelectionChanged = { newSelected ->

                val newList = newSelected.mapNotNull {
                    products.find { product ->
                        product.id == it
                    }
                }
                selectedProducts = newList
            }
        }
        TablePagination {
            this.page = page
            this.count = size
            this.onPageChange = { _, newPage ->
                page = newPage.toInt()
            }
            this.onRowsPerPageChange = { event ->
                rowsPerPage = event.target.asDynamic().value as Int
                page = 0
            }
            this.rowsPerPage = rowsPerPage
        }
    }
}



